import React, { useEffect } from "react";
import FormComponent from "../../../../components/FormComponent";
import FirmInputDetails from "./FirmInputDetails";
import FirmBankDetails from "./FirmBankDetails";
import { Button, Spin, message, Form } from "antd";

import "./style.scss";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { patchOnboardForm } from "../../../../actionsMethods/masterMethods";
import { useLocation, useNavigate } from "react-router";

function FirmDetails({ screen, currentScreen, check, apiResponse }) {
  const dispatch = useDispatch();

  const { error, result, fetching } = useSelector(
    (state) => state.masterReducer.patchOnboardFormReducer,
    shallowEqual
  );

  let firmInitialValues = {
    nameOfProprietor: apiResponse?.miscellaneousDto?.proprietorName,
    IsGSTRegistered: apiResponse?.miscellaneousDto?.gstRegistred?.toString(),
    FirmType: apiResponse?.miscellaneousDto?.firmType,
    MSME: apiResponse?.miscellaneousDto?.msme?.toString(),
    PANNumber: apiResponse?.premiseDto?.pan,
    AccountHolderName: apiResponse?.miscellaneousDto?.accountHolderName,
    AccountNo: apiResponse?.miscellaneousDto?.accountNo,
    IFSCCode: apiResponse?.miscellaneousDto?.ifsc,
    BankName: apiResponse?.miscellaneousDto?.bankName,
    GSTnumber: apiResponse?.premiseDto?.gst,
    NameOfFirm: apiResponse?.miscellaneousDto?.firmName,
  };

  useEffect(() => {
    if (apiResponse) {
      form.setFieldsValue(firmInitialValues);
    }
  }, [apiResponse]);
  const history = useLocation();
  const navigate = useNavigate();

  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [check]);

  useEffect(() => {
    if (
      result !== null &&
      result?.miscellaneousDto["proprietorName"] !== undefined &&
      currentScreen === 1
    ) {
      let temp = {
        ...history?.state,
        premiseDetails: { ...result?.cpDetails?.premiseDetails },
        miscellaneousDetails: { ...result?.cpDetails?.miscellaneousDetails },
        screen: 1,
      };

      navigate("", {
        state: temp,
      });
      screen(2);
    }
    if (error !== null && currentScreen === 1) {
      message.error(error.message || "Something went wrong");
    }
  }, [fetching]);

  const onSubmitFormData = (values) => {
    let data2 = {
      firmDetailsDto: {
        gst: values?.GSTnumber || null,
        pan: values?.PANNumber,
        proprietorName: values?.nameOfProprietor,
        firmName: values?.NameOfFirm || null,
        firmType: values?.FirmType,
        gstRegistred:
          values?.IsGSTRegistered == undefined
            ? false
            : JSON.parse(values?.IsGSTRegistered),
        msme: JSON.parse(values?.MSME),
        accountHolderName: values?.AccountHolderName,
        accountNo: values?.AccountNo,
        ifsc: values?.IFSCCode,
        bankName: values?.BankName,
      },
    };
    let userData = JSON.parse(localStorage.getItem("userinfo"));

    dispatch(
      patchOnboardForm(data2, userData?.userName, apiResponse.premiseId)
    );
  };
  let preFiledData = history.state;

  const formProps = {
    name: "firmDetails",
    className: "register-form",
    initialValues: {
      //   layout: formLayout,
    },
    onFinish: onSubmitFormData,
    autoComplete: "off",
  };

  const formLayout = "vertical";

  return (
    <Spin spinning={fetching}>
      <div className="firm-container">
        <div className="">
          <FormComponent
            formProps={formProps}
            formLayout={formLayout}
            form={form}
            initialValues={{
              nameOfProprietor:
                preFiledData?.miscellaneousDetails?.proprietorName,
              IsGSTRegistered:
                preFiledData?.miscellaneousDetails?.gstRegistred?.toString(),
              FirmType: preFiledData?.miscellaneousDetails?.firmType,
              MSME: preFiledData?.miscellaneousDetails?.msme?.toString(),
              PANNumber: preFiledData?.premiseDetails?.pan,
              AccountHolderName:
                preFiledData?.miscellaneousDetails?.accountHolderName,
              AccountNo: preFiledData?.miscellaneousDetails?.accountNo,
              IFSCCode: preFiledData?.miscellaneousDetails?.ifsc,
              BankName: preFiledData?.miscellaneousDetails?.bankName,
            }}
          >
            <FirmInputDetails form={form} apiResponse={apiResponse} />
            <FirmBankDetails form={form} />
          </FormComponent>
        </div>
      </div>
      <div className="button-container1">
        <div className="steps-action">
          <Button className="back-button" onClick={() => screen(0)}>
            {"BACK"}
          </Button>
          <Button
            htmlType="submit"
            className="next-button"
            form="firmDetails"
            key="submit"
          >
            {"CONTINUE"}
          </Button>
        </div>
      </div>
    </Spin>
  );
}

export default FirmDetails;
